import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::PrefectureArea::AreaRentSp::Component の Stimulus コントローラ。
// landIeul: components/domainParts/AreaRentByPrefectureSp の visibleAreaRentByPrefecture()。
// 15 件ずつのチャンク単位で hidden を外し、残りが無くなったらボタンと帯を DOM から取り除く
// (Next も isInvisibleAreaRentByPrefecture が空になると描画しなくなる)。

class SitePrefectureAreaAreaRentSpController extends Controller<HTMLElement> {
  static targets = ["button", "clearArea"];

  declare readonly buttonTarget: HTMLElement;
  declare readonly clearAreaTargets: HTMLElement[];
  declare readonly hasButtonTarget: boolean;

  private chunk = 0;

  showMore(): void {
    this.cells(this.chunk).forEach((cell) => {
      cell.hidden = false;
    });
    this.chunk += 1;
    if (this.cells(this.chunk).length > 0) return;

    if (this.hasButtonTarget) this.buttonTarget.remove();
    this.clearAreaTargets.forEach((el) => el.remove());
  }

  private cells(chunk: number): HTMLElement[] {
    return Array.from(
      this.element.querySelectorAll<HTMLElement>(`[data-chunk="${chunk}"]`),
    );
  }
}

application.register(
  "site--prefecture-area--area-rent-sp",
  SitePrefectureAreaAreaRentSpController,
);
